<template>
  <div id='page' v-if="player">
    <div>
      <div id='section'>
        <div class="section-title" v-if="player.team || player.joindate || player.transferFee || player.preTeam || player.hisTeam">{{ $t("playerInfo.playingTeam") }}</div>
        <div v-if="player.team"><span class="row0-title">{{ $t("playerInfo.currentTeam") }}</span><span>{{ player.team }}</span></div>
        <hr v-if="player.team"/>
        <div v-if="player.joindate"><span class="row0-title">{{ $t("playerInfo.joinTime") }}</span><span>{{ player.joindate }}</span></div>
        <hr v-if="player.joindate"/>
        <div v-if="player.transferFee"><span class="row0-title">{{ $t("playerInfo.transferFee") }}</span><span v-html="player.transferFee"></span></div>
        <hr v-if="player.transferFee"/>
        <div v-if="player.preTeam"><span class="row0-title">{{ $t("playerInfo.formerTeam") }}</span><span>{{ player.preTeam }}</span></div>
        <hr v-if="player.preTeam"/>
        <div v-if="player.hisTeam"><span class="row0-title">{{ $t("playerInfo.previousTeam") }}</span><span>{{ player.hisTeam }}</span></div>
      </div>
    </div>
    <div id='section' v-if="player.glory">
      <div class="section-title">{{ $t("playerInfo.playerHonor") }}</div>
      <div class="info-content" v-html='escape2Html(player.glory)'></div>
    </div>
    <div id='section' v-if="player.summary">
      <div class="section-title">{{ $t("playerInfo.playerProfile") }}</div>
      <div class="info-content" v-html='escape2Html(player.summary)'/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'player-info',
  props: {
    playerForRoute: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      player: this.playerForRoute
    }
  },
  mounted () {
    if (this.$route.params.playerForRoute) {
      this.player = this.$route.params.playerForRoute
    }
  },
  computed: {
    joinDateStr: function () {
      var joinDateDate = new Date(this.player.joinDate * 1000)
      return joinDateDate.toISOString().split('T')[0]
    }
  },
  methods: {
    escape2Html (str) {
      var arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' }
      return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) { return arrEntities[t] })
    }
  }
}
</script>

<style lang="sass">
@import "style"
</style>
